interface Configuration {
  lob: string;
  coverage: string;
  signinUrl: string;
  brandmarkAffiliate: string;
  brandmarkVariant: string;
  languages: string;
}

interface HeaderData {
  lob: string;
  coverage: string;
  signinUrl: string;
  brandmarkAffiliate: string;
  brandmarkVariant: string;
  languages: string;
}

export const getHeaderContent = (
  configuration: Configuration[],
  lob: string,
  coverage: string
): HeaderData | undefined => {
  if (!lob && !coverage) {
    return undefined;
  }

  // Filter by LOB first
  const lobMatches = configuration?.filter((content) => content.lob === lob);
  if (!lobMatches || lobMatches.length === 0) {
    return undefined;
  }
  // Look for specific coverage match first
  const specificMatch = lobMatches.find((content) => {
    if (!content.coverage) {
      return false;
    }
    const coverageList = content.coverage.split(',').map((c) => c.trim());
    return content.coverage === coverage || coverageList?.includes(coverage);
  });

  if (specificMatch) {
    return specificMatch;
  }

  // Fall back to ALL coverage
  const allMatch = lobMatches.find((content) => content.coverage === 'ALL');
  return allMatch;
};
